/*********************** Custom JS for Boost AI Search & Discovery  ************************/

var cardFetches = [];
var preventReCallProductHandlesTheSame = [];

var customize = {
	updateProductItem: (componentRegistry) => {
		componentRegistry.useComponentPlugin('ProductItem', {
			name: 'Modify Product Item HTML',
			enabled: true,
			apply: () => ({
                beforeRender(element) {                    
					const productData = element.getParams().props.product;

					// Product item element
					const productItem = document.querySelector(`[data-product-id="${productData.id}"]`);

                    // RF: Perform an API request and grab the product card boost snippet - then return that and
                    // overwrite boosts html per card. So we can use our own card
                    const url = `${window.Shopify.routes.root}products/${productData.handle}`;
                    
                    const cardFetch = fetch(`${url}?view=card-boost`, {
                        headers: {
                            'X-Robots-Tag': 'noindex'
                        }
                    })
                    .then((response) => response.text())
                    .then((html) => (productItem.innerHTML = html));

                    cardFetches.push(cardFetch);
                },
			}),
		});
	},

	filterTreeBeforeRender: (componentRegistry) => {
		componentRegistry.useComponentPlugin('FilterTree', {
            name: 'Filter Tree Before Render',
            enabled: true,
            apply: () => ({
                beforeRender(element) {
                    const rootElem = element.getRootElm();
                    const isInitialing = element.isInitialing();

                    if(!isInitialing) {
                        // Move the filters title
                        const filterTitle = document.querySelector('.boost-custom__filters-title');
                        if(!!filterTitle && !!rootElem) rootElem.insertAdjacentElement('afterbegin', filterTitle);
                    }
                },
            }),
        });
    },

	productListAfterRender: (componentRegistry) => {
		componentRegistry.useComponentPlugin('ProductList', {
			name: 'Product List After Render',
			enabled: true,
			apply: () => ({
                beforeRender(element) {
                    const rootElem = element.getRootElm();
                    const isInitialing = element.isInitialing();

                    if(!isInitialing) {
                        // RF: Move collection links
                        const collectionLinks = document.querySelector('.boost-custom__collection-links');
                        if(!!collectionLinks && !!rootElem) rootElem.insertAdjacentElement('beforebegin', collectionLinks);

                        // RF: Move the toolbar
                        const toolbar = document.querySelector('.boost-sd__toolbar-container');
                        if(!!toolbar && !!rootElem) rootElem.insertAdjacentElement('beforebegin', toolbar);

                        // RF: Move custom plp links
                        const customPlpListings = document.querySelectorAll('.boost-sd__product-item--custom');
                        customPlpListings.forEach(listing => {
                            const parent = rootElem.children[2] || rootElem;
                            parent.insertAdjacentElement('afterend', listing);
                        });
                    }
                },
				afterRender(element) {
					// Check duplicate not call. prevent call multi the same value
					const helpersRef = element.getHelpers();
					// Function get all handles displayed in product list
					const productHandles = helpersRef.getProductHandles();
					// Check duplicate not call. prevent call multi the same value
					const isDuplicate =
						JSON.stringify(preventReCallProductHandlesTheSame) ===
						JSON.stringify(productHandles);
					preventReCallProductHandlesTheSame = productHandles;

					if (productHandles?.length && !isDuplicate) {
                        Promise.all(cardFetches).then(() => {
                            // Call extra functions here to run only once after product grid was rendered

                            // RF: Manually dispatch event to re-initialize sections in collections.js
                            document.dispatchEvent(
                                new CustomEvent('shopify:section:load', {
                                    detail: { sectionId: 'collection' },
                                })
                            );

                            // RF: Initialize Yotpo widgets
                            if (window.yotpo !== undefined) {
                                var api = new Yotpo.API(yotpo);
                                api.refreshWidgets();
                            }

                            // RF: Re-init flickity
                            if(!!document.getElementById('shopify-section-collection-boost')) {
                                reInitFlickity('shopify-section-collection-boost');
                            }

                            // RF: Remove temporary content
                            const customCollectionItems = document.querySelector('.boost-custom__collection-items');
                            if (customCollectionItems) customCollectionItems.remove();
                        });
					}
				},
			}),
		});
	},
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
	[customize.updateProductItem],
	[customize.productListAfterRender],
    [customize.filterTreeBeforeRender]
);

var afterPageRender = (element) => {
	// RF: Move the toolbar
	const toolbar = document.querySelector('.boost-sd__toolbar-container');
	const productList = document.querySelector('.boost-sd__product-list');
	productList?.before(toolbar || '');

	// RF: Move collection description
	const collectionDescription = document.querySelector('.collection-description');
	toolbar?.before(collectionDescription || '');

	// RF: Move collection links
	// const collectionLinks = document.querySelector('.collection-links-wrapper');
  // if (collectionDescription) {
	//   collectionDescription?.after(collectionLinks || '');
  // } else {
  //   toolbar?.before(collectionLinks || '');
  // }

	// RF: Add sidebar title
	// @TODO investigate using fetch to get the liquid template
	const sidebarTitle = document.getElementById('sidebar-title');
	const sidebarTitleHtml = '<h2 id="sidebar-title">Filters</h2>';
	const sidebar = document.getElementById('boost-sd__filter-tree-wrapper');

	if (!sidebarTitle && sidebar) {
		sidebar?.insertAdjacentHTML('afterbegin', sidebarTitleHtml);
	}

	// RF: Add header link
	// @TODO investigate using fetch to get the liquid template
	const headerLink = document.getElementById('header-link');
	const headerLinkHtml =
		'<div id="header-link"><a href="https://avon.uk.com/collections/shop-all" title="Shop"><span class="breadcrumb-divider" aria-hidden="true"><svg aria-hidden="true" class="icon icon-arrow-left" viewBox="0 0 16 14"><path d="m6.59 0 1.012 1.074L2.74 6.238H16v1.524H2.74l4.862 5.164L6.591 14 0 7l6.59-7z"></path></svg></span> Browse all Shop</a></div>';
	const header = document.querySelector('.boost-sd__collection-header');

	const isShopAll = window.location.href.indexOf('shop-all') > -1;
	if (!headerLink && header && !isShopAll) {
		header?.insertAdjacentHTML('afterbegin', headerLinkHtml);
	}
    
    // RF: Move custom plp links
    const customPlpListings = document.querySelectorAll('.boost-sd__product-item--custom');
    customPlpListings.forEach(listing => {
        if(productList.children[2]) {
            productList.children[2].insertAdjacentElement('afterend', listing);
        } else {
            productList.insertAdjacentElement('afterbegin', listing);
        }
    });

	// RF: Add header title on search page
	const originalHeaderTitle = document.querySelector(
		'.boost-sd__search-form-title'
	);
	const newHeaderTitleHtml =
		'<h1 class="boost-sd__search-form-title-new">Product Search</h1>';

	if (
		originalHeaderTitle &&
		!document.querySelector('.boost-sd__search-form-title-new')
	) {
		originalHeaderTitle.insertAdjacentHTML('beforebegin', newHeaderTitleHtml);
	}

	// Unhide the page
	const page = document.querySelector('.boost-sd-container');
	page && (page.style.opacity = '1');

	// RF: Use Promise.all to wait for all cards to be built, we don't want this triggering before all the html is added
	Promise.all(cardFetches).then(() => {
		// RF: Manually dispatch event to re-initialize sections in collections.js
		document.dispatchEvent(
			new CustomEvent('shopify:section:load', {
				detail: { sectionId: 'collection' },
			})
		);

		// RF: Initialize Yotpo widgets
		if (window.yotpo !== undefined) {
			var api = new Yotpo.API(yotpo);
			api.refreshWidgets();
		}

        // RF: Re-init flickity
        reInitFlickity('shopify-section-collection-boost');
	});
};


// Update search setting (searchSettings)
if (window.boostSDAppConfig?.searchSettings) {
	window.boostSDAppConfig.searchSettings.suggestionMobileStyle = 'style2';
    window.boostSDAppConfig.searchSettings.highlightSuggestionResult = true;
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
	(componentRegistry) => {
		const addCustomMetafieldIntoDOM = {
			name: 'Add custom metafield into DOM',
			apply() {
				return {
					afterRender(element) {
						// get curr component DOM
						const root = element.getRootElm();

						// traverse to get a suitable node like normal JS
						const right = root.querySelector('.boost-sd__suggestion-queries-item-product--right');

						//Get metafields
						const productData = element.getParams().props.product;
						var perPrice = productData.metafields.find((meta) => meta.key == 'price_per');

						// if metafield
						if (perPrice) {
							var info = [];
							var metafield = document.createElement('div');
							metafield.className = 'boost-sd__suggestion-queries-item-metafield';
							metafield.innerHTML = perPrice.value;

							right.append(metafield);
						}
					},
				};
			},
		};

		componentRegistry.useComponentPlugin('SearchProductItem', addCustomMetafieldIntoDOM);
	},
]);

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
	(registry) => {
		registry.useModulePlugin('SearchAPI', {
			name: 'Custom search title #187052',
			apply(builder) {
				builder.on('methodFulfilled', 'searchInCollection', (result) => {
					if (isSearchPage()) {
						let resultCount = result?.result?.total_product;
						let resultHeaderTitle = document.querySelector(
							'.boost-sd__search-form-title'
						);
						let searchTerm = result?.args[0]?.q ?? '';
						if (typeof resultCount !== 'undefined' && resultHeaderTitle) {
							if (resultHeaderTitle.classList.contains('boost-sd-result-title'))
								return;
							let searchResultText = `${resultCount} ${
								resultCount > 1 ? 'results' : 'result'
							} for "${searchTerm}"`;
							resultHeaderTitle.innerText = searchResultText;
							resultHeaderTitle.classList.add('boost-sd-result-title');
						}
					}
				});
			},
		});
	}
);

function isSearchPage() { 
	return window.boostSDAppConfig?.generalSettings?.page === 'search';
}

/*** custom to remove search value after searching ***/
function removeSearchValue() {
    const btnSearchOpen = document.querySelector('.btn.btn-search-open');
    let isFirstLoad = true;
    const deleteSearchValueInput = () => {
        let allInput = document.querySelectorAll('.boost-sd__search-widget-init-input');
        for (var i = 0; i < allInput.length;i++) {
            allInput[i].value = '';
        }
        isFirstLoad = false;
    }
    document.addEventListener('click', function (params) {
    if (!isFirstLoad) {
        btnSearchOpen.removeEventListener('click',deleteSearchValueInput);
    } 
    });
    if (isFirstLoad && isSearchPage()) {
    btnSearchOpen.addEventListener('click', deleteSearchValueInput);
    }
}

removeSearchValue();
/*** end custom to remove search value after searching ***/

if(boostSDAppConfig?.filterSettings) {
 boostSDAppConfig.filterSettings.filterLayout = 'vertical';
}
